import React from 'react';
import { LandingChartType } from './LandingCharts';
import HistogramGraph from './HistogramGraph';
import { dateFormatter } from '@lib/helpers/formatting';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IcoInfoOutline } from '@icons';

interface HistogramCardProps {
	chart: LandingChartType;
}

const HistogramCard: React.FC<HistogramCardProps> = ({ chart }) => {
	const lastSalStatementDate = chart.extraData?.find((data) => data.key === 'lastDateStatement')?.value;
	const lastSalStatementValue = chart.extraData?.find((data) => data.key === 'lastSalStatement')?.value;

	return (
		<div
			style={{
				backgroundColor: '#fff',
				padding: '1.5rem',
				borderRadius: '1.5rem',
				gridColumn: 'span 2',
			}}
		>
			<div
				style={{
					width: '100%',
				}}
			>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<h4
						style={{
							fontWeight: 700,
						}}
					>
						{chart.title}
					</h4>
					{!!lastSalStatementDate ? (
						<OverlayTrigger
							placement="top"
							popperConfig={{
								modifiers: [
									{
										name: 'flip',
										enabled: true,
										options: {
											fallbackPlacements: ['bottom'],
											padding: 10,
										},
									},
								],
							}}
							overlay={(props) => {
								return (
									<Tooltip {...props} className={`${props.className} half_donut--extra_data_tooltip`}>
										<div style={{ display: 'grid', gap: '1rem', padding: '1rem .5rem' }}>
											<div
												style={{
													textAlign: 'left',
												}}
											>
												<div
													style={{
														fontSize: '12px',
													}}
												>
													<span
														style={{
															fontWeight: 700,
														}}
													>
														Ultima rendicontazione:{' '}
													</span>
													<span>{dateFormatter(lastSalStatementDate as string, 'DD/MM/YYYY')}</span>
												</div>
												<div
													style={{
														fontSize: '12px',
													}}
												>
													<span
														style={{
															fontWeight: 700,
														}}
													>
														N° di SAL:{' '}
													</span>
													<span>{lastSalStatementValue || 'N.D.'}</span>
												</div>
											</div>
										</div>
									</Tooltip>
								);
							}}
						>
							<IcoInfoOutline
								style={{
									fill: 'var(--np-primary-color)',
									marginLeft: 'auto',
								}}
							/>
						</OverlayTrigger>
					) : null}
				</div>
				<HistogramGraph elements={chart.elements} />
			</div>
		</div>
	);
};

export default HistogramCard;
